import React, { Suspense } from "react"
import ReactDOM from "react-dom/client"
import { CssBaseline } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"

import * as Sentry from "@sentry/react"
import { BrowserTracing } from "@sentry/tracing"

import "./styles.css"
import App from "./App"
import Spinner from "components/ui/Spinner"
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  SENTRY_TRACES_SAMPLE_RATE,
} from "config"
import { theme } from "theme"

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: SENTRY_RELEASE,
  integrations: [new BrowserTracing()],
  tracesSampleRate: parseFloat(SENTRY_TRACES_SAMPLE_RATE),
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <Suspense fallback={<Spinner open={true} />}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </Suspense>,
)
